import { IonBackButton, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonSearchbar, IonTitle, IonToast, IonToggle, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React from 'react';
import { getNota } from '../../../../../Utils/Services';

class OperacoesPesquisar extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            notas: [],
            notaDigitada: '',
            pesquisando: false,
            pesquisou: false
        }
        this.getItems = this.getItems.bind(this);
    }

    /*
    componentWillUnmount() {
        this.setState({pesquisou: false, notaDigitada: '', notas: []});
      }
      */
    

    async getItems(filtro: any) {

        let nota = '000000000' + filtro.trim();
        nota = nota.substring(nota.length - 9);

        if (nota == '000000000') return;

        this.setState({ pesquisando: true, pesquisou: false });

        let token: string = "";
        const tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") {
            token = tkn;
        }

        await fetch(getNota.url.replace('{id}', nota),
            {
                method: getNota.method,
                headers: [
                    ["token", token]
                ],
                credentials: 'include'
            }).then(async (resp: Response) => {
                await resp.json().then((res: any) => {
                    this.setState({ notas: res.Items, pesquisou: true });
                });
            }).finally(() => this.setState({ pesquisando: false }));
    }

    render() {
        return (
            <>
                <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonToolbar color='primary' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonButtons slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonButton onClick={() => this.props.setShowModalPesquisar(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon icon={arrowBack} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                            </IonButton>
                        </IonButtons>
                        <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel className="ion-text-wrap" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Pesquisar pela nota fiscal</IonLabel>
                        </IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonItem lines='none' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonSearchbar inputmode='search' value={this.state.notaDigitada} onIonClear={(e) => { this.setState({ pesquisou: false, notaDigitada: '', notas: [] }); } } onKeyPress={(e) => { if (e.key == 'Enter') this.getItems(this.state.notaDigitada); } } onIonChange={(e) => { this.setState({ notaDigitada: e.detail.value }); } } placeholder='Digite o número da nota' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonSearchbar>
                        <IonButton slot='end' fill='clear' color='tertiary' onClick={() => { this.getItems(this.state.notaDigitada); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>pesquisar</IonButton>
                    </IonItem>
                    <br />
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        {this.state.pesquisando ? 'consultando...' : <OperacoesPesquisarLista pesquisou={this.state.pesquisou} notas={this.state.notas} router={this.props.router} setShowModalPesquisar={this.props.setShowModalPesquisar} />}
                    </div>
                </IonContent>
            </>);
    }
}

class OperacoesPesquisarLista extends React.Component<any, any> {
    render() {
        return (
            this.props.pesquisou ?
                (this.props.notas && this.props.notas.hasOwnProperty('length') && this.props.notas.length > 0) ?
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        {this.props.notas.map((valor: any) => (
                            <IonItem lines='full' button={true} detail={true} onClick={() => { this.props.setShowModalPesquisar(false); this.props.router.push("operacoes/acompanhar", { estabelecimento: "A", codigoBarras: "B", operacaoid: valor.sk.replace('operacao#', '').replace(/#/g, '%23') }); } } placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <b>Nota - {valor.numeroNotaFiscal}</b>
                                    <p>{valor.cnpj + ' - ' + valor.razaoSocial}</p>
                                    <p>{valor.sk}</p>
                                </IonLabel>
                            </IonItem>
                        ))}
                    </IonList> :
                    <div style={{ width: '100%', textAlign: 'center' }}><br></br>Nota não encontrada</div> : <></>)
    }
}

export default OperacoesPesquisar;

